import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Alert, Box, Typography,
} from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import { submitKyc } from '../../services/realLotteryApi';

export default function KycDialog({ open, userId, onClose, onSuccess }) {
  const [realName, setRealName] = useState('');
  const [idCard, setIdCard] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setError('');
    if (!realName.trim()) return setError('请输入真实姓名');
    if (!idCard.trim()) return setError('请输入身份证号');
    setLoading(true);
    try {
      const res = await submitKyc({ userId, realName: realName.trim(), idCard: idCard.trim() });
      if (res.success) {
        onSuccess && onSuccess(res.data);
        onClose();
      } else {
        setError(res.message || '提交失败');
      }
    } catch (e) {
      setError(String(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <VerifiedIcon color="primary" />
        实名认证
      </DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          根据国家彩票管理规定，购彩前必须完成实名认证（年满 18 周岁）。
          认证信息仅用于彩票出票和兑奖，受加密存储保护。
        </Alert>
        <TextField
          fullWidth
          label="真实姓名"
          value={realName}
          onChange={(e) => setRealName(e.target.value)}
          margin="normal"
          autoFocus
        />
        <TextField
          fullWidth
          label="身份证号"
          value={idCard}
          onChange={(e) => setIdCard(e.target.value)}
          margin="normal"
          inputProps={{ maxLength: 18 }}
        />
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>
        )}
        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" color="text.secondary">
            * 信息一旦提交不可修改，请仔细核对
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>取消</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>
          {loading ? '提交中…' : '确认提交'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
